import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './ReduxStore';

export interface IApryseEventState {
    currentPage: number;
    currentScale: number;
    selectedAnnotationIds: string[];
}

const initialState: IApryseEventState = {
    currentPage: 1,
    currentScale: 1,
    selectedAnnotationIds: [],
};

const reducers = {
    updateSelectedAnnotations: (state: IApryseEventState, action: PayloadAction<string[]>) => {
        state.selectedAnnotationIds = action.payload;
    },
    updateCurrentPage: (state: IApryseEventState, action: PayloadAction<number>) => {
        state.currentPage = action.payload;
    },
    updateCurrentScale: (state: IApryseEventState, action: PayloadAction<number>) => {
        state.currentScale = action.payload;
    },
};

export const apryseEventSlice = createSlice({
    name: 'apryseEvent',
    initialState,
    reducers,
});

export const apryseEventSliceCurrentPage = (state: IGlobalStoreReducers) =>
    state.apryseEvent.currentPage;
export const apryseEventSliceCurrentScale = (state: IGlobalStoreReducers) =>
    state.apryseEvent.currentScale;
export const apryseEventSliceSelectedAnnotationIds = (state: IGlobalStoreReducers) =>
    state.apryseEvent.selectedAnnotationIds;

export default apryseEventSlice.reducer;
